"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HHNConstants = void 0;
exports.HHNConstants = {
    PAGINATION_LIMIT: 20,
    SYNC_PAGINATION_LIMIT: 100,
    // After a network switch the internet returns well before the socket has
    // reconnected and re-authenticated. A retry tapped in that window waits
    // rather than failing on the spot.
    RETRY_SOCKET_WAIT_MS: 15000,
    MAX_OUTBOX_RECORDS: 50,
    OUTBOX_TTL_MS: 24 * 60 * 60 * 1000,
    // Widen the verify window past the send timestamp so clock skew between the
    // client and the backend can't hide a message that actually landed.
    SEND_VERIFY_LOOKBACK_MS: 5000,
    MESSAGE_PAGINATION_LIMIT: 15,
    GROUP_PAGINATION_LIMIT: 18,
    BROADCAST_PAGINATION_LIMIT: 100,
    SERVER_DATE_FORMAT: "MM/DD/YYYY",
    TIME_VIEW_FORMAT: "hh:mm A",
    DATE_VIEW_FORMAT: "ddd, MMM D",
    HEADER_SOURCE_SYNC: "SYNC",
    OFFLINE_TIMEOUT_DURATION_IN_MINS: 60,
    SYNC_RETAIN_CHAT_COUNT: 2,
    MESSAGE_EDIT_TIME_LIMIT_MS: 15 * 60 * 1000,
};
